import { apiGet, apiPut, apiDelete } from './client';

export interface LabelProjectMapping {
  id: number;
  labelId: number | null;
  label: { id: number; name: string; color: string } | null;
  project: { id: number; name: string | null; fullName: string | null };
}

export async function fetchLabelProjectMappings(): Promise<{ data: LabelProjectMapping[] }> {
  return apiGet('/leads/label-mappings');
}

export async function upsertLabelProjectMapping(
  labelId: number | null,
  projectId: number,
): Promise<{ data: LabelProjectMapping }> {
  return apiPut('/leads/label-mappings', { labelId, projectId });
}

export async function deleteLabelProjectMapping(labelId: number | null): Promise<void> {
  return apiDelete(labelId === null ? '/leads/label-mappings/default' : `/leads/label-mappings/${labelId}`);
}
